// * Bootstrap
// @import "~bootstrap/scss/bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import bootstrap from 'bootstrap'
import { useEffect, useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import ForgetPassword from './Components/Auth/ForgetPassword';
import Login2FA from './Components/Auth/Login2FA';
import RegisterStepOne from './Components/Auth/RegisterStepOne';
import RegisterStepTwo from './Components/Auth/RegisterStepTwo';
import ResetPassword from './Components/Auth/ResetPassword';
import Assurance from './Components/docsAdministrative/Assurance';
import AttestationFiscale from './Components/docsAdministrative/AttestationFiscale';
import AttestationHonneur from './Components/docsAdministrative/AttestationHonneur';
import AttestationUrssaf from './Components/docsAdministrative/AttestationUrssaf';
import CardIdOCR from './Components/docsAdministrative/CardIdOCR';
import ContratHTH from './Components/docsAdministrative/ContratHTH';
import Error404 from './Components/Errors/Error404';
import Error500 from './Components/Errors/Error500';
import Error502 from './Components/Errors/Error502';
import Error503 from './Components/Errors/Error503';
import Unauthorized from './Components/Errors/Unauthorized';
import Layout from './Components/Layout/Layout';
import LayoutConnected from './Components/Layout/LayoutConnected';
import PersistLogin from './Components/PersistLogin';
import RequireAuth from './Components/RequireAuth';
import PrivacyPolicy from './Components/shared/TermsService/PrivacyPolicy';
import TermsService from './Components/shared/TermsService/TermsService';
import AccueilSuiviMission from './Components/suiviMission/AccueilSuiviMission';
import { ROLES } from './config';
import { TaskContextProvider } from './Contexts/suiviMission/TaskContext';
import useAuth from './hooks/useAuth';
import useAxiosPrivate from './hooks/useAxiosPrivate';
import AllRdvs from './Pages/Admin/AllRdvs';
import AoCandidatures from './Pages/Admin/AoCandidatures';
import AllAOs from './Pages/Admin/AOs/AllAOs';
import CalculationSimulator from './Pages/Admin/CalculationSimulator';
import CollaborateurHTH from './Pages/Admin/CollaboratorsHTH/CollaborateurHTH';
import AllAdminMissions from './Pages/Admin/CRAs/AllAdminMissions';
import CreateMission, { MISSION_COMPONENT_TYPES_ENUM } from './Pages/Admin/CRAs/CreateMission';
import DashbordBackOffice from './Pages/Admin/DashbordBackOffice';
import AllInterruptions from './Pages/Admin/DemandeAvalider/AllInterruptions';
import DocumentAdministratifs from './Pages/Admin/DemandeAvalider/DocumentAdministratifs';
import DocumentAdministratifsClient from './Pages/Admin/DemandeAvalider/DocumentAdministratifsClient';
import DocumentAdministratifsEsn from './Pages/Admin/DemandeAvalider/DocumentAdministratifsEsn';
import DocumentAdministratifsExpert from './Pages/Admin/DemandeAvalider/documentAdministratifsExpert';
import InterruptionMission from './Pages/Admin/DemandeAvalider/InterruptionMission';
import InterruptionMissionTraiter from './Pages/Admin/DemandeAvalider/InterruptionMissionTraiter';
import AllDossiers from './Pages/Admin/Dossier/AllDossiers';
import DossierByIdAdmin from './Pages/Admin/Dossier/DossierByIdAdmin';
import EchancierMarges from './Pages/Admin/EchancierMarges';
import Flux from './Pages/Admin/Flux';
import CompteClient from './Pages/Admin/GestionClient/CompteClient';
import DocumentsAdministratifsClient from './Pages/Admin/GestionClient/CompteClientDocAdministratifs';
import CompteClientDocAdministratifsContrat from './Pages/Admin/GestionClient/CompteClientDocAdministratifsContrat';
import CompteClientCollaborateurs from './Pages/Admin/GestionClient/CompteClientDocCollaborateurs';
import CompteClientDocCommerciaux from './Pages/Admin/GestionClient/CompteClientDocCommerciaux';
import CompteClientDonneeFacturationById from './Pages/Admin/GestionClient/CompteClientDonneeFacturation';
import CompteClientPrestationComplementaireById from './Pages/Admin/GestionClient/CompteClientPrestationComplementaire';
import FicheClients from './Pages/Admin/GestionClient/FicheClient';
import AjouterExpertStep1 from './Pages/Admin/GestionExpert/AjouterExpertStep1';
import AjouterExpertStep2 from './Pages/Admin/GestionExpert/AjouterExpertStep2';
import AjouterExpertStep3 from './Pages/Admin/GestionExpert/AjouterExpertStep3';
import AjouterExpertStep4 from './Pages/Admin/GestionExpert/AjouterExpertStep4';
import AssuranceFicheExpert from './Pages/Admin/GestionExpert/Assurance';
import AttestationFiscaleFicheExpert from './Pages/Admin/GestionExpert/AttestationFiscale';
import AttestationHonneurFicheExpert from './Pages/Admin/GestionExpert/AttestationHonneurFicheExpert';
import AttestationUrsafFicheExpert from './Pages/Admin/GestionExpert/AttestationUrsaf';
import ContratFicheExpert from './Pages/Admin/GestionExpert/Contrat';
import DonneeCVFicheExpert from './Pages/Admin/GestionExpert/DonneeCV';
import DonneeCvPartage from './Pages/Admin/GestionExpert/DonneeCvPartage';
import CompteExpert from './Pages/Admin/GestionExpert/DonneePersonnel';
import FicheExperts from './Pages/Admin/GestionExpert/FicheExperts';
import KbisFicheExpert from './Pages/Admin/GestionExpert/Kbis';
import PieceIdentiteFicheExpert from './Pages/Admin/GestionExpert/PieceIdentite';
import PreferenceFicheExpert from './Pages/Admin/GestionExpert/Preference';
import SocieteFicheExpert from './Pages/Admin/GestionExpert/SocieteAdmin';
import AllCraAdmin from './Pages/Admin/Mission/AllCraAdmin';
import AllFacturesBackOffice from './Pages/Admin/Mission/AllFacturesBackOffice';
import Missions from './Pages/Admin/Missions';
import ProfilPersonnelAdmin from './Pages/Admin/profilPersonnelAdmin';
import AllRegularisationAdmin from './Pages/Admin/Regularisation/AllRegularisationAdmin';
import RegularizationNormal from './Pages/Admin/Regularisation/RegularizationNormal';
import RegularizationPC from './Pages/Admin/Regularisation/RegularizationPC';
import Statistiques from './Pages/Admin/Statistiques';
import BlogsHome from './Pages/Blogs/BlogsHome';
import BlogsHomeConsulting from './Pages/Blogs/BlogsHomeConsulting';
import BlogTemplate from './Pages/Blogs/BlogTemplate';
import BlogTemplateConsulting from './Pages/Blogs/BlogTemplateConsulting';
import AllClientMissions from './Pages/Client/AllClientMissions';
import AllPropositionCommerciales from './Pages/Client/AllPropositionCommerciales';
import AllMyAOs from './Pages/Client/AO/AllMyAOs';
import AOdescriptions from './Pages/Client/AO/AOdescriptions';
import AODetails from './Pages/Client/AO/AODetails';
import AoDrafts from './Pages/Client/AO/AoDrafts';
import CreateAO from './Pages/Client/AO/CreateAO';
import CreateAONext from './Pages/Client/AO/CreateAOFirst';
import CreateAOSecond from './Pages/Client/AO/CreateAOSecond';
import CreateAOThird from './Pages/Client/AO/CreateAOThird';
import Collaborators from './Pages/Client/CollaboratorsClient/Collaborators';
import ClientComplete from './Pages/Client/CompleterProfile/ClientComplete';
import ClientStep0 from './Pages/Client/CompleterProfile/ClientStep0';
import ClientStep1 from './Pages/Client/CompleterProfile/ClientStep1';
import ClientStep2 from './Pages/Client/CompleterProfile/ClientStep2';
import ClientStep3 from './Pages/Client/CompleterProfile/ClientStep3';
import ClientStep4 from './Pages/Client/CompleterProfile/ClientStep4';
import CvTheque from './Pages/Client/Cvtheque/CvTheque';
import CvThequeAdvancedSearch from './Pages/Client/Cvtheque/CvThequeAdvancedSearch';
import CvThequeSimpleSearch from './Pages/Client/Cvtheque/CvThequeSimpleSearch';
import DashbordClient from './Pages/Client/DashbordClient';
import DocAdmininstratifClientSidebar from './Pages/Client/DocAdministratifs/DocAdmininstratifClientSidebar';
import KbisClientExpert from './Pages/Client/DocAdministratifs/KbisClientExpert';
import DocCommerciauxClient from './Pages/Client/DocCommerciauxClient';
import AllMyDossier from './Pages/Client/Dossier/AllMyDossier';
import DossierById from './Pages/Client/Dossier/DossierById';
import HomeClient from './Pages/Client/HomeClient';
import AllCraClient from './Pages/Client/Mission/AllCraClient';
import AllFactureClient from './Pages/Client/Mission/AllFactureClient';
import AllRegularisationClient from './Pages/Client/Mission/AllRegularisationClient';
import ParametreCompte from './Pages/Client/ParametreCompte';
import Profile from './Pages/Client/Profile';
import DonneesFacturation from './Pages/Client/ProfileEntreprise/DonneesFacturation';
import DonneesGenerales from './Pages/Client/ProfileEntreprise/DonneesGenerales';
import DonneesPC from './Pages/Client/ProfileEntreprise/DonneesPC';
import Alertes from './Pages/Expert/Alertes';
// import AlertesAdded from './Pages/Expert/AlertesAdded';
// import ProfilEntreprise from './Pages/Client/ProfileEntreprise/ProfilEntreprise'; ////////////////////////////   TO DO  ////////////////////////////////
import AODescriptionById from './Pages/Expert/AO/AODescriptionById';
import Candidatures from './Pages/Expert/AO/Candidatures';
import ListAOs from './Pages/Expert/AO/ListAOs';
import ListAOsFavoris from './Pages/Expert/AO/ListAOsFavoris';
import PostulateToAO from './Pages/Expert/AO/PostulateToAO';
import DonneesPersonnelsExpert, { typeTraitementEnum } from './Pages/Expert/CompleterProfile/DonneesPersonnelsExpert';
import ExpertComplete from './Pages/Expert/CompleterProfile/ExpertComplete';
import ExpertStep0 from './Pages/Expert/CompleterProfile/ExpertStep0';
import ExpertStep1 from './Pages/Expert/CompleterProfile/ExpertStep1';
import ExpertStep2_2 from './Pages/Expert/CompleterProfile/ExpertStep2_2';
import ExpertStep3 from './Pages/Expert/CompleterProfile/ExpertStep3';
import ExpertStep4 from './Pages/Expert/CompleterProfile/ExpertStep4';
import Cra from './Pages/Expert/Cra';
import CraX from './Pages/Expert/CraX';
import DashbordExpert from './Pages/Expert/DashbordExpert';
import DocAdministra from './Pages/Expert/DocAdministra';
import AllCraExpert from './Pages/Expert/Mission/AllCraExpert';
import AllExpertMissions from './Pages/Expert/Mission/AllExpertMissions';
import AllFactureExpert from './Pages/Expert/Mission/AllFactureExpert';
import AllOrdreMissions from './Pages/Expert/Mission/AllOrdreMissions';
import AllRegularisationExpert from './Pages/Expert/Mission/AllRegularisationExpert';
import DonneeProfile from './Pages/Expert/Profile/DonneeProfile';
import PreferenceGeneralise from './Pages/Expert/Profile/PreferenceGeneralise';
import SocieteGeneralisation from './Pages/Expert/Profile/SocieteGeneralisation';
import AboutUsConsulting from './Pages/Home/AboutUsConsulting';
import ConsultingServices from './Pages/Home/ConsultingServices';
import ContactUsConsulting from './Pages/Home/ContactUsConsulting';
import DemandeDemo from './Pages/Home/DemandeDemo';
import GlobalHome from './Pages/Home/GlobalHome';
import GlobalHomeClient from './Pages/Home/GlobalHomeClient';
//import ExpertVitrine from './Pages/Home/Expert';
import HomePage from './Pages/Home/Home';
import HomeESN from './Pages/Home/HomeESN';
import HomeExpert from './Pages/Home/HomeExpert';
import HomePageConsulting from './Pages/Home/HomePageConsulting';
import PourquoiHTH from './Pages/Home/PourquoiHTH';
import Pricing from './Pages/Home/Pricing';
import QuiSommesNs from './Pages/Home/QuiSommesNs';
import WhyHtHConsulting from './Pages/Home/WhyHtHConsulting';
// ! suiviMission
// import Accueil from './Pages/suiviMission/Accueil';
import CollaboratorsSuiviMission from './Pages/suiviMission/CollaboratorsSuiviMission';
import Dashboard from './Pages/suiviMission/Dashboard';
import Notifications from './Pages/suiviMission/Notifications';
import Ressources from './Pages/suiviMission/Ressources';
import Tasks from './Pages/suiviMission/Tasks';
import Conversation from './Utils/Conversations/Conversation';
import Conversations from './Utils/Conversations/Conversations';
import PlateFormeUtilitiesComponent from './Utils/PlateFormeUtilitiesComponent';

export default function App() {

    const { auth } = useAuth();
    const [permissionToHide,setPermissionToHide]=useState(false);
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        if (auth.roles == ROLES.Admin)
            getMyInfos();
    }, [auth]);

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get('admin/getMyInfos');
            if((response.data?.backOffice?.roles?.chargeRecrutement==1)){
                setPermissionToHide(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <Routes>
                <Route>
                    {/* <Route element={<PersistLogin />} > */}
                    <Route
                        path="/"
                        element={<Layout />}
                    >
                        {/* public route */}
                        <Route
                            path=""
                            element={<GlobalHome />}
                        />
                        <Route
                            path="Sourcing"
                            element={<HomePage />}
                        />
                        <Route
                            path="ConsultingServices"
                            element={<ConsultingServices />}
                        />
                        <Route
                            path="WhyHtHConsulting"
                            element={<WhyHtHConsulting />}
                        />
                        <Route
                            path="ContactUs"
                            element={<ContactUsConsulting />}
                        />

                        <Route
                            path="AboutUsConsulting"
                            element={<AboutUsConsulting />}
                        />
                        <Route
                            path="Consulting"
                            element={<HomePageConsulting />}
                        />
                        <Route
                            path="/Consultingblogs/:id"
                            element={<BlogTemplateConsulting />}
                        />
                        <Route
                            path="Consultingblogs"
                            element={<BlogsHomeConsulting />}
                        />
                        <Route
                            path="HTH"
                            element={<QuiSommesNs />}
                        />
                        <Route
                            path="whyHtH"
                            element={<PourquoiHTH />}
                        />
                        <Route
                            path="pricing"
                            element={<Pricing />}
                        />
                        <Route
                            path="/blog/:id"
                            element={<BlogTemplate />}
                        />
                        <Route
                            path="blogs"
                            element={<BlogsHome />}
                        />
                        <Route
                            path="demo"
                            element={<DemandeDemo />}
                        />
                        <Route
                            path="termsOfService"
                            element={<TermsService />}
                        />
                        <Route
                            path="privacyPolicy"
                            element={<PrivacyPolicy />}
                        />
                        <Route
                            path="homeExpert"
                            element={<HomeExpert />}
                        />
                        <Route
                            path="homeClient"
                            element={<GlobalHomeClient />}
                        />
                        <Route
                            path="homeESN"
                            element={<HomeESN />}
                        />
                        <Route
                            path="register"
                            element={<RegisterStepOne />}
                        />
                        <Route
                            path="almostDone"
                            element={<RegisterStepTwo />}
                        />
                        <Route
                            path="login"
                            element={<Login2FA />}
                        />

                        <Route
                            path="forgetPassword"
                            element={<ForgetPassword />}
                        />
                        <Route
                            path="resetPassword/:AT"
                            element={<ResetPassword />}
                        />
                        <Route
                            path="resetPassword"
                            element={<ResetPassword />}
                        />
                        <Route
                            path="unauthorized"
                            element={<Unauthorized />}
                        />
                        <Route
                            // index
                            path="welcomeCompletion"
                            element={<ClientStep0 />}
                        />
                    </Route>

                    {/* protected routes */}
                    {/* //! : we check persist login only inside protected routes, but now we do it inside all the plateform, what I did nt  like : it could be bad for performance .. especially for new visitors */}
                    <Route element={<PersistLogin />} >
                        <Route
                            path=''
                            element={<LayoutConnected />}
                        >
                            <Route element={<RequireAuth allowedRoles={[ROLES.Client]} />}>
                                {/* <Route
                                    path="client"
                                    element={<Outlet />}
                                > */}
                                <Route
                                    path="client"
                                    element={<HomeClient />}
                                >
                                    <Route
                                        // index
                                        path="cvTheque"
                                        element={<CvTheque />}
                                    >
                                        <Route
                                            index
                                            // path="cvTheque"
                                            element={<CvThequeSimpleSearch />}
                                        />
                                        <Route
                                            path='advanced'
                                            element={<CvThequeAdvancedSearch />}
                                        />
                                    </Route>
                                    <Route
                                        path="completeProfile"
                                        element={<ClientComplete />}
                                    >
                                        <Route
                                            index
                                            path=""
                                            element={<ClientStep1 />}
                                        />
                                        <Route
                                            path="step2"
                                            element={<ClientStep2 />}
                                        />
                                        <Route
                                            path="step3"
                                            element={<ClientStep3 />
                                            }
                                        />
                                        <Route
                                            path="step4"
                                            element={<ClientStep4 />
                                            }
                                        />
                                    </Route>
                                    <Route
                                        path="collaborators"
                                        element={<Collaborators />}
                                    />
                                    <Route
                                        path="createAO"
                                        element={<CreateAO />}
                                    >
                                        <Route
                                            path=""
                                            element={<CreateAONext />}
                                        />
                                        <Route
                                            path="next"
                                            element={<CreateAOSecond />}
                                        />
                                        <Route
                                            path="last"
                                            element={<CreateAOThird />}
                                        />
                                    </Route>
                                    <Route
                                        path="drafts"
                                        element={<AoDrafts />}
                                    />
                                    <Route
                                        path="profile"
                                        element={<Profile />}
                                    />
                                    <Route
                                        path="parametreCompte"
                                        element={<ParametreCompte />}
                                    />
                                    <Route
                                        path="aos"
                                        element={<AllMyAOs />}
                                    />
                                    <Route
                                        path="ao/:aoId"
                                        element={<AODetails />}
                                    />
                                    <Route
                                        path="ao/aoDetails/:aoId"
                                        element={<AOdescriptions />}
                                    />
                                    <Route
                                        path="mission"
                                        element={<AllClientMissions />}
                                    />
                                    <Route
                                        path="propositionCommercial"
                                        element={<AllPropositionCommerciales />}
                                    />
                                    {/* // ! RDV //to be separated */}
                                    <Route
                                        path="AllCras"
                                        element={<AllCraClient />}
                                    />
                                    {/* ! VAlidation */}
                                    <Route
                                        path="Cra/:craId"
                                        element={<Cra />}
                                    />
                                    <Route
                                        path="CraX/:craXId"
                                        element={<CraX />}
                                    />
                                    {/* Factures */}
                                    <Route
                                        path="AllFactures"
                                        element={<AllFactureClient />}
                                    />
                                    {/* Regularisation */}
                                    <Route
                                        path="AllRegularisation"
                                        element={<AllRegularisationClient />}
                                    />
                                    <Route
                                        path="dashbordClient"
                                        element={<DashbordClient />}
                                    />
                                    {/* // ! RDV //to be separated */}
                                    <Route
                                        path="gestionRDV"
                                        element={<AllRdvs />}
                                    />
                                    {/* // ! Suivi Mission */}
                                    <Route
                                        path="suiviMission"
                                        element={
                                            <Dashboard />
                                        }
                                    >
                                        {/*<Route
                                            index
                                            path=""
                                            element={<AllClientMissions />}
                                        />*/}
                                        <Route
                                            path="Accueil"
                                            element={<AccueilSuiviMission />}
                                        />
                                        <Route
                                            path="Tasks"
                                            element={
                                                <TaskContextProvider>
                                                    <Tasks />
                                                </TaskContextProvider>
                                            }
                                        />
                                        <Route
                                            path="Ressources"
                                            element={<Ressources />}
                                        />
                                        <Route
                                            path="Notifications"
                                            element={<Notifications />}
                                        />
                                        <Route
                                            path="CollaboratorsSuiviMission"
                                            element={<CollaboratorsSuiviMission />}
                                        />
                                    </Route>
                                    <Route
                                        //index
                                        path='donneesGenerales'
                                        element={<DonneesGenerales />}
                                    />
                                    <Route
                                        path='donneesFacturation'
                                        element={<DonneesFacturation />}
                                    />
                                    <Route
                                        path='donneesPC'
                                        element={<DonneesPC />}
                                    />
                                    <Route
                                        path="docAdmininstratif"
                                        element={<DocAdmininstratifClientSidebar />}
                                    >
                                        {/*On a supprimer le contrat cote client (a voir apres)*/}
                                        <Route
                                            index
                                            // path='donneesGenerales'
                                            element={<KbisClientExpert />}
                                        />
                                    </Route>
                                    <Route
                                        path='docCommerciaux'
                                        element={<DocCommerciauxClient />}
                                    />
                                    <Route
                                        path='AllMyDossier'
                                        element={<AllMyDossier />}
                                    />
                                    <Route
                                        path='dossier/:dossierId'
                                        element={<DossierById />}
                                    />
                                    <Route
                                        path="conversation"
                                        element={<Conversations />}
                                    >
                                        <Route
                                            path=":to"
                                            element={<Conversation />}
                                        />
                                    </Route>
                                    <Route
                                        path="RegularizationPC"
                                        element={<RegularizationPC />}
                                    />
                                    <Route
                                        path="NormalRegularization"
                                        element={<RegularizationNormal />}
                                    />
                                </Route>
                            </Route>
                            <Route element={<RequireAuth allowedRoles={[ROLES.Expert]} />}>
                                <Route
                                    path="expert"
                                    element={<Outlet />}
                                >
                                    <Route
                                        // path="aos"
                                        index
                                        element={<ListAOs />}
                                    />
                                    <Route
                                        path="completeProfile"
                                        element={<ExpertComplete />}
                                    >
                                        <Route
                                            index
                                            path="stepsToFollow"
                                            element={<ExpertStep0 />}
                                        />
                                        <Route
                                            // index
                                            path=""
                                            element={<ExpertStep1 />}
                                        />
                                        <Route
                                            index
                                            path="step2"
                                            element={<ExpertStep2_2 />}
                                        />
                                        <Route
                                            path="step3"
                                            element={<ExpertStep3 />}
                                        />
                                        <Route
                                            path="step4"
                                            element={<ExpertStep4 />}
                                        />
                                    </Route>
                                    <Route
                                        path="profile"
                                        element={<Profile />}
                                    />
                                    <Route
                                        path="parametreCompte"
                                        element={<ParametreCompte />}
                                    />
                                    <Route
                                        path="aosFavoris"
                                        element={<ListAOsFavoris />}
                                    />
                                    <Route
                                        path="ao/:AOid"
                                        element={<AODescriptionById />}
                                    />
                                    <Route
                                        path="ao/postulate/:AOid"
                                        element={<PostulateToAO />}
                                    />
                                    <Route
                                        path="candidatures"
                                        element={<Candidatures />}
                                    />
                                    <Route
                                        path="candidatures/:AOid"
                                        element={<AODescriptionById />}
                                    />
                                    <Route
                                        path="alertes"
                                        element={<Alertes />}
                                    />
                                    <Route
                                        path="ordreMission"
                                        element={<AllOrdreMissions />}
                                    />
                                    <Route
                                        path="mission"
                                        element={<AllExpertMissions />}
                                    />
                                    <Route
                                        path="AllCras"
                                        element={<AllCraExpert />}
                                    />
                                    {/* ! VAlidation */}
                                    <Route
                                        path="Cra/:craId"
                                        element={<Cra />}
                                    />
                                    <Route
                                        path="CraX/:craXId"
                                        element={<CraX />}
                                    />
                                    <Route
                                        path="CraX"
                                        element={<CraX />}
                                    />
                                    <Route
                                        path="dashbordExpert"
                                        element={<DashbordExpert />}
                                    />
                                    {/* Factures */}
                                    <Route
                                        path="AllFactures"
                                        element={<AllFactureExpert />}
                                    />
                                    <Route
                                        path="AllRegularisation"
                                        element={<AllRegularisationExpert />}
                                    />
                                    <Route
                                        path="docAdministrative"
                                        element={<DocAdministra />}
                                    >
                                        <Route
                                            index
                                            // path='pieceIdentite'
                                            element={<CardIdOCR />}
                                        />
                                        <Route
                                            path='contratHTH'
                                            element={<ContratHTH />}
                                        />
                                        <Route
                                            path='kbis'
                                            element={<KbisClientExpert />}
                                        />
                                        <Route
                                            path='attestationFiscale'
                                            element={<AttestationFiscale />}
                                        />
                                        <Route
                                            path='attestationUrssaf'
                                            element={<AttestationUrssaf />}
                                        />
                                        <Route
                                            path='assurance'
                                            element={<Assurance />}
                                        />
                                        <Route
                                            path='attestationHonneur'
                                            element={<AttestationHonneur />}
                                        />
                                    </Route>
                                    <Route
                                        path="donneeProfile"
                                        element={<DonneeProfile />}
                                    >
                                        <Route
                                            index
                                            // path='profilepersonnel'
                                            element={<DonneesPersonnelsExpert typeTraitement={typeTraitementEnum.EXPERT_UPDATE} />}
                                        />
                                        <Route
                                            path='donneesCV'
                                            element={<DonneeCvPartage typeTraitement={typeTraitementEnum.EXPERT_UPDATE} />}
                                        />
                                        <Route
                                            path='preferences'
                                            element={<PreferenceGeneralise typeTraitement={typeTraitementEnum.EXPERT_UPDATE} />}
                                        />
                                        <Route
                                            path='societe'
                                            element={<SocieteGeneralisation typeTraitement={typeTraitementEnum.EXPERT_UPDATE} />}
                                        />
                                    </Route>
                                    <Route
                                        path="gestionRDV"
                                        element={<AllRdvs />}
                                    />
                                    <Route
                                        path="conversation"
                                        element={<Conversations />}
                                    >
                                        <Route
                                            path=":to"
                                            element={<Conversation />}
                                        />
                                    </Route>
                                    <Route
                                        path="RegularizationPC"
                                        element={<RegularizationPC />}
                                    />
                                    <Route
                                        path="NormalRegularization"
                                        element={<RegularizationNormal />}
                                    />
                                </Route>
                            </Route>
                            <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
                                <Route
                                    path="admin"
                                    element={<Outlet />}
                                >
                                    {permissionToHide==false &&
                                        <Route
                                            index
                                            //path="dashbordBackOffice"
                                            element={<DashbordBackOffice />}
                                        />
                                    }
                                    <Route
                                        //index
                                        path="profilPersonnel"
                                        element={<ProfilPersonnelAdmin />}
                                    />
                                    <Route
                                        //index
                                        path="parametreCompte"
                                        element={<ParametreCompte />}
                                    />
                                    <Route
                                        //index
                                        path="createMission"
                                        element={ <CreateMission  mission_component_type={MISSION_COMPONENT_TYPES_ENUM.create} />}
                                    />
                                    <Route
                                        //index
                                        path="modify/:missionId"
                                        element={ <CreateMission  mission_component_type={MISSION_COMPONENT_TYPES_ENUM.modify} />}
                                    />
                                    <Route
                                        //index
                                        path="renewBDC/:missionId"
                                        element={ <CreateMission  mission_component_type={MISSION_COMPONENT_TYPES_ENUM.renew} />}
                                    />
                                    {permissionToHide==true ?
                                        <Route
                                            index
                                            //path="mission"
                                            element={<AllAdminMissions />}
                                        />
                                        :
                                        <Route
                                            path="mission"
                                            element={<AllAdminMissions />}
                                        />
                                    }
                                    <Route
                                        path="collaborateurHTH"
                                        element={<CollaborateurHTH />}
                                    />
                                    <Route
                                        path="AllCras"
                                        element={<AllCraAdmin />}
                                    />
                                    <Route
                                        path="Cra/:craId"
                                        element={<Cra />}
                                    />
                                    <Route
                                        path="CraX/:craXId"
                                        element={<CraX />}
                                    />
                                    <Route
                                        path="RegularizationPC"
                                        element={<RegularizationPC />}
                                    />
                                    <Route
                                        path="createAO"
                                        element={<CreateAO />}
                                    >
                                        <Route
                                            path=""
                                            element={<CreateAONext />}
                                        />
                                        <Route
                                            path="next"
                                            element={<CreateAOSecond />}
                                        />
                                        <Route
                                            path="last"
                                            element={<CreateAOThird />}
                                        />
                                    </Route>

                                    {/* Factures */}
                                    <Route
                                        path="AllFactures"
                                        element={<AllFacturesBackOffice />}
                                    />
                                    {/* Regularization */}
                                    <Route
                                        path="AllRegularisation"
                                        element={<AllRegularisationAdmin />}
                                    />
                                    <Route
                                        path="NormalRegularization"
                                        element={<RegularizationNormal />}
                                    />
                                    <Route
                                        path='AllDossiers'
                                        element={<AllDossiers />}
                                    />
                                    <Route
                                        path='dossier/:dossierId'
                                        element={<DossierByIdAdmin />}
                                    />
                                    <Route
                                        path="AddExpertStep1"
                                        element={<AjouterExpertStep1 />}
                                    />
                                    <Route
                                        path="AddExpertStep2"
                                        element={<AjouterExpertStep2 />}
                                    />
                                    <Route
                                        path="AddExpertStep3"
                                        element={<AjouterExpertStep3 />}
                                    />
                                    <Route
                                        path="AddExpertStep4"
                                        element={<AjouterExpertStep4 />}
                                    />
                                    <Route
                                        path="gestionClient"
                                        element={<FicheClients />}
                                    />
                                    <Route
                                        path="gestionClient/:ClientId/CompteClient"
                                        element={<CompteClient />}
                                    />
                                    <Route
                                        path="gestionClient/:ClientId/DonneeFacturation"
                                        element={<CompteClientDonneeFacturationById />}
                                    />
                                    <Route
                                        path="gestionClient/:ClientId/PrestationComplementaire"
                                        element={<CompteClientPrestationComplementaireById />}
                                    />
                                    <Route
                                        path="gestionClient/:ClientId/CompteClientDocAdministratifs"
                                        element={<DocumentsAdministratifsClient />}
                                    />
                                    <Route
                                        path="gestionClient/:ClientId/CompteClientDocAdministratifsContrat"
                                        element={<CompteClientDocAdministratifsContrat />}
                                    />
                                    <Route
                                        path="gestionClient/:ClientId/CompteClientDocCommerciaux"
                                        element={<CompteClientDocCommerciaux />}
                                    />
                                    <Route
                                        path="gestionClient/:ClientId/CompteClientCollaborateurs"
                                        element={<CompteClientCollaborateurs />}
                                    />
                                    <Route
                                        path="gestionExperts"
                                        element={<FicheExperts />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/DonneePersonnel"
                                        element={<CompteExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/DonneeCV"
                                        element={<DonneeCVFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Societe"
                                        element={<SocieteFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Preference"
                                        element={<PreferenceFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/PieceIdentite"
                                        element={<PieceIdentiteFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Contrat"
                                        element={<ContratFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Kbis"
                                        element={<KbisFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/AttestationUrsaf"
                                        element={<AttestationUrsafFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Assurance"
                                        element={<AssuranceFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/AttestationHonneur"
                                        element={<AttestationHonneurFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/AttestationFiscale"
                                        element={<AttestationFiscaleFicheExpert />}
                                    />
                                    <Route
                                        path="gestionEsn"
                                        element={<FicheClients />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/CompteClient"
                                        element={<CompteClient />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/DonneeFacturation"
                                        element={<CompteClientDonneeFacturationById />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/PrestationComplementaire"
                                        element={<CompteClientPrestationComplementaireById />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/CompteClientDocAdministratifs"
                                        element={<DocumentsAdministratifsClient />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/PieceIdentite"
                                        element={<PieceIdentiteFicheExpert />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/Contrat"
                                        element={<ContratFicheExpert />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/Kbis"
                                        element={<KbisFicheExpert />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/AttestationUrsaf"
                                        element={<AttestationUrsafFicheExpert />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/Assurance"
                                        element={<AssuranceFicheExpert />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/AttestationHonneur"
                                        element={<AttestationHonneurFicheExpert />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/AttestationFiscale"
                                        element={<AttestationFiscaleFicheExpert />}
                                    />

                                    <Route
                                        path="gestionEsn/:EsnId/CompteClientDocAdministratifsContrat"
                                        element={<CompteClientDocAdministratifsContrat />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/CompteClientDocCommerciaux"
                                        element={<CompteClientDocCommerciaux />}
                                    />
                                    <Route
                                        path="gestionEsn/:EsnId/CompteClientCollaborateurs"
                                        element={<CompteClientCollaborateurs />}
                                    />
                                    <Route
                                        path="documentAdministratifs"
                                        element={<DocumentAdministratifs />}
                                    >
                                        <Route
                                            index
                                            // path="cvTheque"
                                            element={<DocumentAdministratifsClient />}
                                        />
                                        <Route
                                            path='Expert'
                                            element={<DocumentAdministratifsExpert />}
                                        />
                                        <Route
                                            path='Esn'
                                            element={<DocumentAdministratifsEsn />}
                                        />
                                    </Route>
                                    <Route
                                        path="gestionRDV"
                                        element={<AllRdvs />}
                                    />
                                    <Route
                                        path="InterruptionsMissions"
                                        element={<AllInterruptions />}
                                    >
                                        <Route
                                            index
                                            // path="cvTheque"
                                            element={<InterruptionMission />}
                                        />
                                        <Route
                                            path='Traitees'
                                            element={<InterruptionMissionTraiter />}
                                        />
                                    </Route>
                                    <Route
                                        path="calculationSimulator"
                                        element={<CalculationSimulator />}
                                    />
                                    <Route
                                        path="statistiques"
                                        element={<Statistiques />}
                                    >
                                        <Route
                                            index
                                            // path="cvTheque"
                                            element={<Flux />}
                                        />
                                        <Route
                                            index
                                            path="aoCandidatures"
                                            element={<AoCandidatures />}
                                        />
                                        <Route
                                            index
                                            path="echancierMarges"
                                            element={<EchancierMarges />}
                                        />
                                        <Route
                                            index
                                            path="missions"
                                            element={<Missions />}
                                        />
                                    </Route>
                                    <Route
                                        path="aos"
                                        element={<AllAOs />}
                                    />
                                    <Route
                                        path="ao/:aoId"
                                        element={<AODetails />}
                                    />
                                    <Route
                                        path="ao/aoDetails/:aoId"
                                        element={<AOdescriptions />}
                                    />
                                    <Route
                                        path="createAO"
                                        element={<CreateAO />}
                                    >
                                        <Route
                                            path=""
                                            element={<CreateAONext />}
                                        />
                                        <Route
                                            path="next"
                                            element={<CreateAOSecond />}
                                        />
                                        <Route
                                            path="last"
                                            element={<CreateAOThird />}
                                        />
                                    </Route>
                                    <Route
                                        path="conversation"
                                        element={<Conversations />}
                                    >
                                        <Route
                                            path=":to"
                                            element={<Conversation />}
                                        />
                                    </Route>
                                </Route>
                            </Route>
                            <Route element={<RequireAuth allowedRoles={[ROLES.Esn]} />}>
                                <Route
                                    path="esn"
                                    element={<HomeClient />}
                                >
                                    <Route
                                        // index
                                        path="cvTheque"
                                        element={<CvTheque />}
                                    >
                                        <Route
                                            index
                                            // path="cvTheque"
                                            element={<CvThequeSimpleSearch />}
                                        />
                                        <Route
                                            path='advanced'
                                            element={<CvThequeAdvancedSearch />}
                                        />
                                    </Route>
                                    <Route
                                        path="completeProfile"
                                        element={<ClientComplete />}
                                    >
                                        <Route
                                            index
                                            path=""
                                            element={<ClientStep1 />}
                                        />
                                        <Route
                                            path="step2"
                                            element={<ClientStep2 />}
                                        />
                                        <Route
                                            path="step3"
                                            element={<ClientStep3 />
                                            }
                                        />
                                        <Route
                                            path="step4"
                                            element={<ClientStep4 />
                                            }
                                        />
                                    </Route>
                                    <Route
                                        path="collaborators"
                                        element={<Collaborators />}
                                    />
                                    <Route
                                        path="createAO"
                                        element={<CreateAO />}
                                    >
                                        <Route
                                            path=""
                                            element={<CreateAONext />}
                                        />
                                        <Route
                                            path="next"
                                            element={<CreateAOSecond />}
                                        />
                                        <Route
                                            path="last"
                                            element={<CreateAOThird />}
                                        />
                                    </Route>
                                    <Route
                                        path="drafts"
                                        element={<AoDrafts />}
                                    />
                                    <Route
                                        path="profile"
                                        element={<Profile />}
                                    />
                                    <Route
                                        path="parametreCompte"
                                        element={<ParametreCompte />}
                                    />
                                    <Route
                                        path="gestionExperts"
                                        element={<FicheExperts />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats"
                                        element={<FicheExperts />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/DonneePersonnel"
                                        element={<CompteExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/DonneeCV"
                                        element={<DonneeCVFicheExpert />}
                                    />

                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/Preference"
                                        element={<PreferenceFicheExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/PieceIdentite"
                                        element={<PieceIdentiteFicheExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/Contrat"
                                        element={<ContratFicheExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/Kbis"
                                        element={<KbisFicheExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/AttestationUrsaf"
                                        element={<AttestationUrsafFicheExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/Assurance"
                                        element={<AssuranceFicheExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/AttestationHonneur"
                                        element={<AttestationHonneurFicheExpert />}
                                    />
                                    <Route
                                        path="gestionDossiersCandidats/:ExpertId/AttestationFiscale"
                                        element={<AttestationFiscaleFicheExpert />}
                                    />

                                    <Route
                                        path="gestionExperts/:ExpertId/DonneePersonnel"
                                        element={<CompteExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/DonneeCV"
                                        element={<DonneeCVFicheExpert />}
                                    />

                                    <Route
                                        path="gestionExperts/:ExpertId/Preference"
                                        element={<PreferenceFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/PieceIdentite"
                                        element={<PieceIdentiteFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Contrat"
                                        element={<ContratFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Kbis"
                                        element={<KbisFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/AttestationUrsaf"
                                        element={<AttestationUrsafFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/Assurance"
                                        element={<AssuranceFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/AttestationHonneur"
                                        element={<AttestationHonneurFicheExpert />}
                                    />
                                    <Route
                                        path="gestionExperts/:ExpertId/AttestationFiscale"
                                        element={<AttestationFiscaleFicheExpert />}
                                    />
                                    <Route
                                        path="AddExpertStep1"
                                        element={<AjouterExpertStep1 />}
                                    />
                                    <Route
                                        path="AddExpertStep2"
                                        element={<AjouterExpertStep2 />}
                                    />
                                    <Route
                                        path="AddExpertStep3"
                                        element={<AjouterExpertStep3 />}
                                    />

                                    <Route
                                        path="aosHTH"
                                        index
                                        element={<ListAOs />}
                                    />
                                    <Route
                                        path="aosFavoris"
                                        element={<ListAOsFavoris />}
                                    />
                                    <Route
                                        path="aoHTH/:AOid"
                                        element={<AODescriptionById />}
                                    />
                                    <Route
                                        path="aoHTH/postulate/:AOid"
                                        element={<PostulateToAO />}
                                    />
                                    <Route
                                        path="candidatures"
                                        element={<Candidatures />}
                                    />
                                    <Route
                                        path="candidatures/:AOid"
                                        element={<AODescriptionById />}
                                    />
                                    <Route
                                        path="aos"
                                        element={<AllMyAOs />}
                                    />
                                    <Route
                                        path="ao/details/:aoId"
                                        element={<AODetails />}
                                    />
                                    <Route
                                        path="ao/aoDetails/:aoId"
                                        element={<AOdescriptions />}
                                    />
                                    {/* <Route
                                        path="ao/:aoId"
                                        element={<AOdescriptions />}
                                    /> */}
                                    <Route
                                        path="mission"
                                        element={<AllClientMissions/>}
                                    />
                                    <Route
                                        path="missionVente"
                                        element={<AllExpertMissions />}
                                    />
                                    <Route
                                        path="propositionCommercial"
                                        element={<AllPropositionCommerciales />}
                                    />
                                    {/* // ! RDV //to be separated */}
                                    <Route
                                        path="AllCras"
                                        element={<AllCraClient />}
                                    />
                                    {/* ! VAlidation */}
                                    <Route
                                        path="Cra/:craId"
                                        element={<Cra />}
                                    />
                                    <Route
                                        path="CraX/:craXId"
                                        element={<CraX />}
                                    />
                                    <Route
                                        path="AllCrasVente"
                                        element={<AllCraExpert />}
                                    />
                                    {/* ! VAlidation */}
                                    <Route
                                        path="craVente/:craId"
                                        element={<Cra />}
                                    />
                                    <Route
                                        path="craXVente/:craXId"
                                        element={<CraX />}
                                    />
                                    <Route
                                        path="ordreMission"
                                        element={<AllOrdreMissions />}
                                    />
                                    {/* Factures */}
                                    <Route
                                        path="AllFactures"
                                        element={<AllFactureClient />}
                                    />
                                    {/* Regularisation */}
                                    <Route
                                        path="AllRegularisation"
                                        element={<AllRegularisationClient />}
                                    />

                                    <Route
                                        path="AllFacturesVente"
                                        element={<AllFactureExpert />}
                                    />
                                    {/* Regularisation */}
                                    <Route
                                        path="AllRegularisationVente"
                                        element={<AllRegularisationExpert />}
                                    />
                                    <Route
                                        path="dashbordClient"
                                        element={<DashbordClient />}
                                    />
                                    {/* // ! RDV //to be separated */}
                                    <Route
                                        path="gestionRDV"
                                        element={<AllRdvs />}
                                    />
                                    {/* // ! Suivi Mission */}
                                    <Route
                                        path="suiviMission"
                                        element={
                                            <Dashboard />
                                        }
                                    >
                                        {/*<Route
                                            index
                                            path=""
                                            element={<AllClientMissions />}
                                        />*/}
                                        <Route
                                            path="Accueil"
                                            element={<AccueilSuiviMission />}
                                        />
                                        <Route
                                            path="Tasks"
                                            element={
                                                <TaskContextProvider>
                                                    <Tasks />
                                                </TaskContextProvider>
                                            }
                                        />
                                        <Route
                                            path="Ressources"
                                            element={<Ressources />}
                                        />
                                        <Route
                                            path="Notifications"
                                            element={<Notifications />}
                                        />
                                        <Route
                                            path="CollaboratorsSuiviMission"
                                            element={<CollaboratorsSuiviMission />}
                                        />
                                    </Route>
                                    <Route
                                        //index
                                        path='donneesGenerales'
                                        element={<DonneesGenerales />}
                                    />
                                    <Route
                                        path='donneesFacturation'
                                        element={<DonneesFacturation />}
                                    />
                                    <Route
                                        path='donneesPC'
                                        element={<DonneesPC />}
                                    />
                                    {/* <Route
                                        path="docAdmininstratif"
                                        element={<DocAdmininstratifClientSidebar />}
                                    >
                                        <Route
                                            index
                                            // path='donneesGenerales'
                                            element={<KbisClientExpert />}
                                        />
                                    </Route> */}
                                    <Route
                                        path="docAdministrative"
                                        element={<DocAdministra />}
                                    >
                                        <Route
                                            index
                                            // path='pieceIdentite'
                                            element={<CardIdOCR />}
                                        />
                                        <Route
                                            path='contratHTH'
                                            element={<ContratHTH />}
                                        />
                                        <Route
                                            path='kbis'
                                            element={<KbisClientExpert />}
                                        />
                                        <Route
                                            path='attestationFiscale'
                                            element={<AttestationFiscale />}
                                        />
                                        <Route
                                            path='attestationUrssaf'
                                            element={<AttestationUrssaf />}
                                        />
                                        <Route
                                            path='assurance'
                                            element={<Assurance />}
                                        />
                                        <Route
                                            path='attestationHonneur'
                                            element={<AttestationHonneur />}
                                        />
                                    </Route>
                                    <Route
                                        path='docCommerciaux'
                                        element={<DocCommerciauxClient />}
                                    />
                                    <Route
                                        path='AllMyDossier'
                                        element={<AllMyDossier />}
                                    />
                                    <Route
                                        path='dossier/:dossierId'
                                        element={<DossierById />}
                                    />
                                    <Route
                                        path="conversation"
                                        element={<Conversations />}
                                    >
                                        <Route
                                            path=":to"
                                            element={<Conversation />}
                                        />
                                    </Route>
                                    <Route
                                        path="RegularizationPC"
                                        element={<RegularizationPC />}
                                    />
                                    <Route
                                        path="NormalRegularization"
                                        element={<RegularizationNormal />}
                                    />
                                </Route>
                            </Route>
                        </Route>
                    </Route>
                    {/* catch all */}
                    <Route
                        path="*"
                        element={<Error404 />}
                    />
                    <Route
                        path="Error503"
                        element={<Error503 />}
                    />
                    <Route
                        path="Error502"
                        element={<Error502 />}
                    />
                    <Route
                        path="Error500"
                        element={<Error500 />}
                    />
                </Route>
            </Routes>
            <PlateFormeUtilitiesComponent />
        </>
    );
}
